import { documentsApi } from 'api';

export const orderCaseDocuments = async (documentsId: string[]) => {
  return await documentsApi.renderDocuments({ documentsId: { documentsId: documentsId.map(Number) } });
};
